<template>
  <div>

    <hr class="my-4 border-gray-200 dark:border-gray-700" />

    <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mb-4">
      <div v-for="field in inputFields" :key="field" class="mb-1">
        <div v-if="field.startsWith('X')" class="mb-1"></div>
        <PredefinedValuesInputComponent
          v-else-if="predefined.includes(field)"
          category="main"
          :name="field"
          :append-on-select="true"
          v-model="mainForm[field]"
          :placeholder="$t(`messages.detail.main.${field}`)"
          @update:model-value="evaluationStore.save({ assessment_data: { [field]: $event } })"
        />
        <DatePicker
          v-else-if="dateFields.includes(field)"
          :key="field"
          class="mb-1"
          :date-format="'dd.mm.yy'"
          fluid
          showIcon
          :placeholder="$t(`messages.detail.main.${field}`)"
          v-model="mainForm[field]"
          @update:model-value="setDate($event, field)"
        />
        <InputText
          v-else
          v-model="mainForm[field]"
          :name="field"
          fluid
          :placeholder="$t(`messages.detail.main.${field}`)"
          @update:model-value="evaluationStore.save({ assessment_data: { [field]: $event } })"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia'
import { useI18n } from 'vue-i18n'
import PredefinedValuesInputComponent from '@/components/PredefinedValuesInputComponent.vue'
import { useFormatDate } from '@/composables/useFormatDate'
import { DETAIL_DATE_FIELDS } from '@/constants'
import { useDetailStore } from '@/stores/useDetailStore'
import { useEvaluationStore } from '@/stores/useEvaluationStore'
import { useTransactionStore } from '@/stores/transaction'

const { t } = useI18n()

const { formatDatePickerToISO, formatISOToDatePicker, formatDate } = useFormatDate()

const detailStore = useDetailStore()
const evaluationStore = useEvaluationStore()
const transactionStore = useTransactionStore()

const { mainForm } = storeToRefs(detailStore)

const inputFields = [
  'aadress',
  'hindamise_eesmark',
  'ylevaatuse_hindaja',
  'registriosa_nr',

  'vara',
  'tellija',
  'ylevaatuse_juures',
  'omandivorm',

  'omanik',
  'tellimusleping',
  'ylevaatuse_kuupaev',
  'katastritunnus',

  // 'yldine_seisukord',
  'eeldused',
  'vaartuse_kuupaev',
  'eriomandi_pind',

  'likviidsus',
  'yyrilepingud',
  'aruande_kuupaev',
  'erikasutus',

  'hindamise_tapsus',
  'kaibemaks',
  'ylevaatuse_ulatus',
  'mottlise_osa_suurus',

  'X2',
  'X3',
  'ylevaatuse_pohjalikkus',
  'notariaalne_kaasomandi_kokkulepe',
]

const predefined = [
  'omandivorm',
  'eeldused',
  'yyrilepingud',
  'vara',
  // 'yldine_seisukord',
  'hindamise_eesmark',
  'likviidsus',
  'hindamise_tapsus',
  'ylevaatuse_ulatus',
  'ylevaatuse_pohjalikkus',
  'kaibemaks',
  'ylevaatuse_hindaja',
  'ylevaatuse_juures',
  'tellimusleping',
  'erikasutus',
  'notariaalne_kaasomandi_kokkulepe',
]

const dateFields = DETAIL_DATE_FIELDS

const setDate = (date, field) => {
  const dateString = formatDatePickerToISO(date)

  mainForm.value[field] = dateString
  evaluationStore.save({ assessment_data: { [field]: dateString } })

  if (field === 'vaartuse_kuupaev') {
    transactionStore.masterData.aol_kpv = formatDate(dateString)
  }
}
</script>
